import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/30 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="flex items-center gap-3">
              <img 
                src="https://framerusercontent.com/images/mCmSpcpcYCZJTSJSoearkxxG0FQ.png?width=236&height=240" 
                alt="AttentionLabs" 
                className="h-10 w-10"
              />
              {/* <span className="text-white font-bold text-xl" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                AttentionLabs
              </span> */}
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a 
              href="/methodology" 
              className="text-white hover:text-purple-400 transition-colors"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Methodology
            </a>
            <a 
              href="/#services" 
              className="text-white hover:text-purple-400 transition-colors"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Services
            </a>
            <a 
              href="/portfolio" 
              className="text-white hover:text-purple-400 transition-colors"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Portfolio
            </a>
            <a 
              href="/casestudies" 
              className="text-white hover:text-purple-400 transition-colors"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Case Studies
            </a>
            <a 
              href="/intelligence" 
              className="text-white hover:text-purple-400 transition-colors"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Intelligence
            </a>
            <a 
              href="/contact" 
              className="px-6 py-2 bg-white text-black font-semibold rounded-lg hover:bg-white/90 transition-all"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Apply for Sprint
            </a>
          </nav>

          {/* Mobile menu button */}
          <button 
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-50 md:hidden"
            style={{ backgroundColor: '#000000' }}
          >
            <div className="flex flex-col h-full bg-black">
              {/* Mobile Header */}
              <div className="flex items-center justify-between p-4 border-b border-white/10">
                <div className="flex items-center gap-3">
                  <img 
                    src="https://framerusercontent.com/images/mCmSpcpcYCZJTSJSoearkxxG0FQ.png?width=236&height=240" 
                    alt="AttentionLabs" 
                    className="h-10 w-10"
                  />
                  {/* <span className="text-white font-bold text-xl" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    AttentionLabs
                  </span> */}
                </div>
                <button 
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white"
                >
                  <X size={24} />
                </button>
              </div>

              {/* Mobile Navigation */}
              <nav className="flex flex-col p-8 gap-6 bg-black">
                <a 
                  href="/" 
                  className="text-2xl text-white hover:text-purple-400 transition-colors"
                  style={{ fontFamily: 'Space Grotesk, sans-serif' }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Home
                </a>
                <a 
                  href="/methodology" 
                  className="text-2xl text-white hover:text-purple-400 transition-colors"
                  style={{ fontFamily: 'Space Grotesk, sans-serif' }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Methodology
                </a>
                <a 
                  href="/#services" 
                  className="text-2xl text-white hover:text-purple-400 transition-colors"
                  style={{ fontFamily: 'Space Grotesk, sans-serif' }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Services
                </a>
                <a 
                  href="/portfolio" 
                  className="text-2xl text-white hover:text-purple-400 transition-colors"
                  style={{ fontFamily: 'Space Grotesk, sans-serif' }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Portfolio
                </a>
                <a 
                  href="/casestudies" 
                  className="text-2xl text-white hover:text-purple-400 transition-colors"
                  style={{ fontFamily: 'Space Grotesk, sans-serif' }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Case Studies
                </a>
                <a 
                  href="/intelligence" 
                  className="text-2xl text-white hover:text-purple-400 transition-colors"
                  style={{ fontFamily: 'Space Grotesk, sans-serif' }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Intelligence
                </a>
                
                <a 
                  href="/contact" 
                  className="mt-8 px-8 py-4 bg-white text-black font-semibold rounded-lg hover:bg-white/90 transition-all text-center"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Apply for Sprint
                </a>
              </nav>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
